import { RichtextSectionWithBorder, RichtextSectionWithBorderProps } from './RichtextSectionWithBorder'

export default RichtextSectionWithBorder

export { type RichtextSectionWithBorderProps, RichtextSectionWithBorder }
